module.exports = "pegasus_template/assets/tech/plain/plain-image.png";